<template>
  <div class="common_problem">
    <Header :title="{name: '常见问题'}">
    </Header>
    <div class="content"
         v-html="content">

    </div>
    <Empty class="emptyImg"
           v-if="content == ''"
           :empty_type="{ name: '暂无常见问题', img:emptyImg}"></Empty>
  </div>
</template>

<script>
import Header from '@/components/Header'
import Empty from "@/components/Empty";
import emptyImg from '@/assets/images/answer_empty.png';
export default {
  name: 'common_problem',
  components: {
    Header, Empty
  },
  data () {
    return {
      content: '',
      emptyImg
    }
  },
  created () {
    this.requestData();
  },
  methods: {
    // request
    requestData () {
      this.$http.get('/api/lector/teacher/account/commonProblems').then(data => {
        this.content = data.common_problems;
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.common_problem {
  @extend %default-bg;
  background-color: #fff;
  font-family: PingFang SC;
  font-size: 30px;
  .content {
    padding: 30px;
  }
}
</style>